import { render } from "./LanguageSection.vue?vue&type=template&id=61451add&scoped=true"
import script from "./LanguageSection.vue?vue&type=script&lang=js"
export * from "./LanguageSection.vue?vue&type=script&lang=js"

import "./LanguageSection.vue?vue&type=style&index=0&id=61451add&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61451add"

export default script